import {
  patchState,
  signalStoreFeature,
  withMethods,
  withState,
} from '@ngrx/signals'
import { ApiValidationResult } from '../../../core/models/api-validation-result'

interface State {
  errors: ApiValidationResult | null
}

export function withErrors<_>() {
  return signalStoreFeature(
    withState({
      errors: null,
    } as State),
    withMethods((store) => ({
      setErrors(errors: ApiValidationResult | null) {
        patchState(store, setErrors(errors))
      },
    }))
  )
}

export function setErrors(errors: ApiValidationResult | null): Partial<State> {
  return { errors }
}
